import React from 'react';
import * as Colors from '../../utils/Color';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';


const styles = {
    radioButton: {
        marginBottom: 0,
        width: "auto",
        marginRight: "25px",
    },
    iconStyle: {
        fill: Colors.primary,
        marginRight: 0
    },
    labelStyle: {
        fontWeight: "bold",
        fontSize: "14px",
        marginLeft: "7px",
        width: "100%"
    },
};

const Radio = props => {
    const { name, onChange, labelFirst, labelSecond, valueFirst, valueSecond, error, value, MenuItemRadio } = props;
    const className= MenuItemRadio ? "radio" : "radio flex-center-y";
    const firstRadioButton = {...styles.radioButton, marginBottom: "20px"};
    return (
        <React.Fragment>
            <RadioButtonGroup onChange={ (e, v) => onChange(e, v) }
                              name={ name }
                              defaultSelected={value}
                              className={className} >
                <RadioButton
                    value={ valueFirst }
                    label={ labelFirst }
                    labelStyle={styles.labelStyle}
                    iconStyle={styles.iconStyle}
                    style={firstRadioButton}
                />
                <RadioButton
                    value={ valueSecond }
                    label={ labelSecond }
                    labelStyle={styles.labelStyle}
                    iconStyle={styles.iconStyle}
                    style={styles.radioButton}
                />
            </RadioButtonGroup>
            { error ?  <span className="error-msg mb-10" >{ error }</span> : null }
        </React.Fragment>
    );
};


export default Radio;


// WEBPACK FOOTER //
// ./src/components/UI/Radio-f.js